import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CampaignsIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#00D2D2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M28.0186 23.0455H16.4081C15.8388 23.0455 15.3773 23.507 15.3773 24.0763C15.3773 24.6455 15.8388 25.107 16.4081 25.107H27.4662L24.2097 37.2606H22.1928C14.9066 37.2606 9 31.354 9 24.0678C9 16.7816 14.9066 10.875 22.1928 10.875H31.2797L28.0186 23.0455Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M32.0706 37.2606H26.4842L29.7408 25.107C32.5593 25.107 34.6108 27.7805 33.8813 30.503L32.0706 37.2606Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M37.3254 17.6494C36.4726 20.8323 33.5883 23.0455 30.2932 23.0455L33.5542 10.875H39.1406L37.3254 17.6494Z",
                fill: "white"
            })
        ]
    });
